// extracted by mini-css-extract-plugin
export default {"items":"Form_items__WQOm5","item":"Form_item__PMuQz","icon":"Form_icon__Ai2-X","info":"Form_info__9nP-K"};